import { formatPattern } from "react-router-utils";
import ImmutablePropTypes from "react-immutable-proptypes";
import ModalAddToCart from "app/components/ModalAddToCart";
import PreviousLink from "app/components/UI/PreviousLink";
import ProductDetail from "./ProductDetail";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "app/components/UI/Spinner";
import classes from "./ProductPage.module.css";

export const ProductPage = ({
  clubId,
  translate,
  isLoading,
  product,
  productBehavior,
  offer,
  onAddToCart,
  onClose,
  isOpen,
  isPrepareCart
}) =>
  isLoading ? (
    <Spinner absolute />
  ) : (
    <div className={classes.pageContainer}>
      <PreviousLink to={formatPattern("/:clubId/shop", { clubId: clubId })}>{translate("Le Practice")}</PreviousLink>

      <ProductDetail
        clubId={clubId}
        isPrepareCart={isPrepareCart}
        product={product}
        productBehavior={productBehavior}
        offer={offer}
        onAddToCart={onAddToCart}
      />

      <ModalAddToCart open={isOpen} onRequestClose={onClose} clubId={clubId}>
        <div className={classes.modal__productName}>{product.getIn(["publicMetadata", "title"])}</div>
        <div className={classes.modal__productDescription}>{product.getIn(["publicMetadata", "subTitle"])}</div>
      </ModalAddToCart>
    </div>
  );

ProductPage.propTypes = {
  translate: PropTypes.func.isRequired,
  clubId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  product: ImmutablePropTypes.map,
  productBehavior: ImmutablePropTypes.map,
  offer: ImmutablePropTypes.map,
  onAddToCart: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isPrepareCart: PropTypes.bool.isRequired
};

export default ProductPage;



// WEBPACK FOOTER //
// ./src/app/components/ProductPage/ProductPage.js